/* tslint:disable */
/* eslint-disable */
/**
 * Flow Learning - OpenAPI 3.1
 * api for flow learning
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: floTeam@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Edge
 */
export interface Edge {
    /**
     * 
     * @type {string}
     * @memberof Edge
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Edge
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof Edge
     */
    'target'?: string;
}
/**
 * 
 * @export
 * @interface FlowNode
 */
export interface FlowNode {
    /**
     * 
     * @type {string}
     * @memberof FlowNode
     */
    'id'?: string;
    /**
     * 
     * @type {FlowNodePosition}
     * @memberof FlowNode
     */
    'position'?: FlowNodePosition;
    /**
     * 
     * @type {string}
     * @memberof FlowNode
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowNode
     */
    'targetPosition'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlowNode
     */
    'SourcePosition'?: string;
    /**
     * 
     * @type {FlowNodeData}
     * @memberof FlowNode
     */
    'data'?: FlowNodeData;
}
/**
 * 
 * @export
 * @interface FlowNodeData
 */
export interface FlowNodeData {
    /**
     * 
     * @type {string}
     * @memberof FlowNodeData
     */
    'title'?: string;
    /**
     * 
     * @type {number}
     * @memberof FlowNodeData
     */
    'battleTested'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowNodeData
     */
    'fresh'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowNodeData
     */
    'speed'?: number;
}
/**
 * 
 * @export
 * @interface FlowNodePosition
 */
export interface FlowNodePosition {
    /**
     * 
     * @type {number}
     * @memberof FlowNodePosition
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowNodePosition
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface LinkData
 */
export interface LinkData {
    /**
     * 
     * @type {string}
     * @memberof LinkData
     */
    'link'?: string;
    /**
     * 
     * @type {number}
     * @memberof LinkData
     */
    'votes'?: number;
    /**
     * 
     * @type {UserIdentifier}
     * @memberof LinkData
     */
    'addedBy'?: UserIdentifier;
    /**
     * 
     * @type {string}
     * @memberof LinkData
     */
    'dateAdded'?: string;
}
/**
 * 
 * @export
 * @interface Login
 */
export interface Login {
    /**
     * 
     * @type {string}
     * @memberof Login
     */
    'ssoProvider'?: LoginSsoProviderEnum;
}

export const LoginSsoProviderEnum = {
    Google: 'google',
    Facebook: 'facebook',
    Microsoft: 'microsoft',
    X: 'x',
    Apple: 'apple',
    Discord: 'discord'
} as const;

export type LoginSsoProviderEnum = typeof LoginSsoProviderEnum[keyof typeof LoginSsoProviderEnum];

/**
 * 
 * @export
 * @interface MapData
 */
export interface MapData {
    /**
     * 
     * @type {Array<FlowNode>}
     * @memberof MapData
     */
    'nodes': Array<FlowNode>;
    /**
     * 
     * @type {Array<Edge>}
     * @memberof MapData
     */
    'edges': Array<Edge>;
}
/**
 * 
 * @export
 * @interface NodeData
 */
export interface NodeData {
    /**
     * 
     * @type {string}
     * @memberof NodeData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NodeData
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof NodeData
     */
    'topic'?: string;
    /**
     * 
     * @type {number}
     * @memberof NodeData
     */
    'battleTested'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodeData
     */
    'fresh'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodeData
     */
    'speed'?: number;
    /**
     * 
     * @type {string}
     * @memberof NodeData
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NodeData
     */
    'isFlagged'?: boolean;
    /**
     * 
     * @type {Array<LinkData>}
     * @memberof NodeData
     */
    'youtubeLinks'?: Array<LinkData>;
    /**
     * 
     * @type {UserIdentifier}
     * @memberof NodeData
     */
    'createdBy'?: UserIdentifier;
    /**
     * 
     * @type {Array<UserIdentifier>}
     * @memberof NodeData
     */
    'editedBy'?: Array<UserIdentifier>;
}
/**
 * 
 * @export
 * @interface RequestPostNode
 */
export interface RequestPostNode {
    /**
     * 
     * @type {string}
     * @memberof RequestPostNode
     */
    'source': string;
    /**
     * 
     * @type {string}
     * @memberof RequestPostNode
     */
    'target': string;
    /**
     * 
     * @type {string}
     * @memberof RequestPostNode
     */
    'topic': string;
}
/**
 * 
 * @export
 * @interface ResponseAuth2
 */
export interface ResponseAuth2 {
    /**
     * 
     * @type {boolean}
     * @memberof ResponseAuth2
     */
    'isAuth': boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponseAuth2
     */
    'role': number;
}
/**
 * 
 * @export
 * @interface ResponseAuth4
 */
export interface ResponseAuth4 {
    /**
     * 
     * @type {boolean}
     * @memberof ResponseAuth4
     */
    'isAuth'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseAuth4
     */
    'error'?: boolean;
}
/**
 * 
 * @export
 * @interface ResponseCookie
 */
export interface ResponseCookie {
    /**
     * 
     * @type {string}
     * @memberof ResponseCookie
     */
    'w_authExp'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseCookie
     */
    'w_auth'?: string;
}
/**
 * 
 * @export
 * @interface ResponsePostNode
 */
export interface ResponsePostNode {
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNode
     */
    'targetId': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNode
     */
    'sourceId': string;
}
/**
 * 
 * @export
 * @interface ResponsePostTopic
 */
export interface ResponsePostTopic {
    /**
     * 
     * @type {Topic}
     * @memberof ResponsePostTopic
     */
    'topic': Topic;
    /**
     * 
     * @type {NodeData}
     * @memberof ResponsePostTopic
     */
    'nodeData': NodeData;
}
/**
 * 
 * @export
 * @interface ResponseUserInfoInner
 */
export interface ResponseUserInfoInner {
    /**
     * 
     * @type {string}
     * @memberof ResponseUserInfoInner
     */
    'topic'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseUserInfoInner
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseUserInfoInner
     */
    'nodeId'?: string;
}
/**
 * 
 * @export
 * @interface Topic
 */
export interface Topic {
    /**
     * 
     * @type {string}
     * @memberof Topic
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'provider'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastLogin'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email'?: string;
    /**
     * User Status
     * @type {number}
     * @memberof User
     */
    'role'?: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'reputation'?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'location'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isFlagged'?: boolean;
    /**
     * 
     * @type {Array<ResponseUserInfoInner>}
     * @memberof User
     */
    'battleTestedUp'?: Array<ResponseUserInfoInner>;
    /**
     * 
     * @type {Array<ResponseUserInfoInner>}
     * @memberof User
     */
    'battleTestedDown'?: Array<ResponseUserInfoInner>;
    /**
     * 
     * @type {Array<ResponseUserInfoInner>}
     * @memberof User
     */
    'freshUp'?: Array<ResponseUserInfoInner>;
    /**
     * 
     * @type {Array<ResponseUserInfoInner>}
     * @memberof User
     */
    'freshDown'?: Array<ResponseUserInfoInner>;
    /**
     * 
     * @type {Array<ResponseUserInfoInner>}
     * @memberof User
     */
    'edited'?: Array<ResponseUserInfoInner>;
    /**
     * 
     * @type {Array<ResponseUserInfoInner>}
     * @memberof User
     */
    'created'?: Array<ResponseUserInfoInner>;
    /**
     * 
     * @type {Array<LinkData>}
     * @memberof User
     */
    'linked'?: Array<LinkData>;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    'videoUp'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    'videoDown'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UserIdentifier
 */
export interface UserIdentifier {
    /**
     * 
     * @type {string}
     * @memberof UserIdentifier
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserIdentifier
     */
    'id'?: string;
}

/**
 * AllApi - axios parameter creator
 * @export
 */
export const AllApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary gets clip image
         * @param {string} clipUrl url of clip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clipImage: async (clipUrl: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clipUrl' is not null or undefined
            assertParamExists('clipImage', 'clipUrl', clipUrl)
            const localVarPath = `/clip/{clipUrl}`
                .replace(`{${"clipUrl"}}`, encodeURIComponent(String(clipUrl)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AllApi - functional programming interface
 * @export
 */
export const AllApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AllApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary gets clip image
         * @param {string} clipUrl url of clip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clipImage(clipUrl: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clipImage(clipUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllApi.clipImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AllApi - factory interface
 * @export
 */
export const AllApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AllApiFp(configuration)
    return {
        /**
         * 
         * @summary gets clip image
         * @param {string} clipUrl url of clip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clipImage(clipUrl: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.clipImage(clipUrl, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AllApi - object-oriented interface
 * @export
 * @class AllApi
 * @extends {BaseAPI}
 */
export class AllApi extends BaseAPI {
    /**
     * 
     * @summary gets clip image
     * @param {string} clipUrl url of clip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AllApi
     */
    public clipImage(clipUrl: string, options?: RawAxiosRequestConfig) {
        return AllApiFp(this.configuration).clipImage(clipUrl, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MapApi - axios parameter creator
 * @export
 */
export const MapApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new edge
         * @summary Add a new edge
         * @param {string} topicId ID of topic to return a map for
         * @param {Edge} edge Create a new edge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEdge: async (topicId: string, edge: Edge, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('addEdge', 'topicId', topicId)
            // verify required parameter 'edge' is not null or undefined
            assertParamExists('addEdge', 'edge', edge)
            const localVarPath = `/map/{topicId}/edge`
                .replace(`{${"topicId"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(edge, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete edge
         * @summary delete edge
         * @param {string} topicId ID of topic to return a map for
         * @param {string} edgeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEdge: async (topicId: string, edgeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('deleteEdge', 'topicId', topicId)
            // verify required parameter 'edgeId' is not null or undefined
            assertParamExists('deleteEdge', 'edgeId', edgeId)
            const localVarPath = `/map/{topicId}/edge`
                .replace(`{${"topicId"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (edgeId !== undefined) {
                localVarQueryParameter['edgeId'] = edgeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a single topic map
         * @summary Find map by ID
         * @param {string} topicId ID of topic to return a map for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMapById: async (topicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('getMapById', 'topicId', topicId)
            const localVarPath = `/map/{topicId}`
                .replace(`{${"topicId"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MapApi - functional programming interface
 * @export
 */
export const MapApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MapApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new edge
         * @summary Add a new edge
         * @param {string} topicId ID of topic to return a map for
         * @param {Edge} edge Create a new edge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEdge(topicId: string, edge: Edge, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEdge(topicId, edge, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MapApi.addEdge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete edge
         * @summary delete edge
         * @param {string} topicId ID of topic to return a map for
         * @param {string} edgeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEdge(topicId: string, edgeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEdge(topicId, edgeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MapApi.deleteEdge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a single topic map
         * @summary Find map by ID
         * @param {string} topicId ID of topic to return a map for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMapById(topicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MapData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMapById(topicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MapApi.getMapById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MapApi - factory interface
 * @export
 */
export const MapApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MapApiFp(configuration)
    return {
        /**
         * Add a new edge
         * @summary Add a new edge
         * @param {string} topicId ID of topic to return a map for
         * @param {Edge} edge Create a new edge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEdge(topicId: string, edge: Edge, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addEdge(topicId, edge, options).then((request) => request(axios, basePath));
        },
        /**
         * delete edge
         * @summary delete edge
         * @param {string} topicId ID of topic to return a map for
         * @param {string} edgeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEdge(topicId: string, edgeId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEdge(topicId, edgeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single topic map
         * @summary Find map by ID
         * @param {string} topicId ID of topic to return a map for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMapById(topicId: string, options?: RawAxiosRequestConfig): AxiosPromise<MapData> {
            return localVarFp.getMapById(topicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MapApi - object-oriented interface
 * @export
 * @class MapApi
 * @extends {BaseAPI}
 */
export class MapApi extends BaseAPI {
    /**
     * Add a new edge
     * @summary Add a new edge
     * @param {string} topicId ID of topic to return a map for
     * @param {Edge} edge Create a new edge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapApi
     */
    public addEdge(topicId: string, edge: Edge, options?: RawAxiosRequestConfig) {
        return MapApiFp(this.configuration).addEdge(topicId, edge, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete edge
     * @summary delete edge
     * @param {string} topicId ID of topic to return a map for
     * @param {string} edgeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapApi
     */
    public deleteEdge(topicId: string, edgeId: string, options?: RawAxiosRequestConfig) {
        return MapApiFp(this.configuration).deleteEdge(topicId, edgeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a single topic map
     * @summary Find map by ID
     * @param {string} topicId ID of topic to return a map for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapApi
     */
    public getMapById(topicId: string, options?: RawAxiosRequestConfig) {
        return MapApiFp(this.configuration).getMapById(topicId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NodeApi - axios parameter creator
 * @export
 */
export const NodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new node
         * @summary Add a new node
         * @param {NodeData} nodeData Create a new node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNode: async (nodeData: NodeData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeData' is not null or undefined
            assertParamExists('addNode', 'nodeData', nodeData)
            const localVarPath = `/node`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nodeData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a specific node.
         * @summary Delete a node
         * @param {string} nodeId 
         * @param {string} tid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNode: async (nodeId: string, tid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('deleteNode', 'nodeId', nodeId)
            // verify required parameter 'tid' is not null or undefined
            assertParamExists('deleteNode', 'tid', tid)
            const localVarPath = `/node`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (tid !== undefined) {
                localVarQueryParameter['tid'] = tid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get wiki node
         * @summary get wiki node
         * @param {string} nodeId 
         * @param {string} tid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNode: async (nodeId: string, tid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('getNode', 'nodeId', nodeId)
            // verify required parameter 'tid' is not null or undefined
            assertParamExists('getNode', 'tid', tid)
            const localVarPath = `/node`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (tid !== undefined) {
                localVarQueryParameter['tid'] = tid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get next top battle tested ID
         * @summary get next top battle tested ID
         * @param {string} nodeId 
         * @param {string} tid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeNextBattleTested: async (nodeId: string, tid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('getNodeNextBattleTested', 'nodeId', nodeId)
            // verify required parameter 'tid' is not null or undefined
            assertParamExists('getNodeNextBattleTested', 'tid', tid)
            const localVarPath = `/node/nextBattleTested`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (tid !== undefined) {
                localVarQueryParameter['tid'] = tid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get next top fresh ID
         * @summary get next top fresh ID
         * @param {string} nodeId 
         * @param {string} tid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeNextFresh: async (nodeId: string, tid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('getNodeNextFresh', 'nodeId', nodeId)
            // verify required parameter 'tid' is not null or undefined
            assertParamExists('getNodeNextFresh', 'tid', tid)
            const localVarPath = `/node/nextFresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nodeId !== undefined) {
                localVarQueryParameter['nodeId'] = nodeId;
            }

            if (tid !== undefined) {
                localVarQueryParameter['tid'] = tid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing node
         * @summary battle vote a node
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeBattleVote: async (nodeData: NodeData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeData' is not null or undefined
            assertParamExists('updateNodeBattleVote', 'nodeData', nodeData)
            const localVarPath = `/node/battleVote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nodeData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing node
         * @summary fresh vote a node
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeFlag: async (nodeData: NodeData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeData' is not null or undefined
            assertParamExists('updateNodeFlag', 'nodeData', nodeData)
            const localVarPath = `/node/flag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nodeData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing node
         * @summary fresh vote a node
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeFreshVote: async (nodeData: NodeData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeData' is not null or undefined
            assertParamExists('updateNodeFreshVote', 'nodeData', nodeData)
            const localVarPath = `/node/freshVote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nodeData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing node
         * @summary Update a nodes title and description
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeTitle: async (nodeData: NodeData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeData' is not null or undefined
            assertParamExists('updateNodeTitle', 'nodeData', nodeData)
            const localVarPath = `/node/title`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nodeData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing node
         * @summary add or remove videos from a node
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeVideoEdit: async (nodeData: NodeData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeData' is not null or undefined
            assertParamExists('updateNodeVideoEdit', 'nodeData', nodeData)
            const localVarPath = `/node/videoEdit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nodeData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing node
         * @summary Update a nodes video votes
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeVideoVote: async (nodeData: NodeData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeData' is not null or undefined
            assertParamExists('updateNodeVideoVote', 'nodeData', nodeData)
            const localVarPath = `/node/videoVote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nodeData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NodeApi - functional programming interface
 * @export
 */
export const NodeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NodeApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new node
         * @summary Add a new node
         * @param {NodeData} nodeData Create a new node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNode(nodeData: NodeData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePostNode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNode(nodeData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeApi.addNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a specific node.
         * @summary Delete a node
         * @param {string} nodeId 
         * @param {string} tid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNode(nodeId: string, tid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNode(nodeId, tid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeApi.deleteNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get wiki node
         * @summary get wiki node
         * @param {string} nodeId 
         * @param {string} tid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNode(nodeId: string, tid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNode(nodeId, tid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeApi.getNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get next top battle tested ID
         * @summary get next top battle tested ID
         * @param {string} nodeId 
         * @param {string} tid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNodeNextBattleTested(nodeId: string, tid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNodeNextBattleTested(nodeId, tid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeApi.getNodeNextBattleTested']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get next top fresh ID
         * @summary get next top fresh ID
         * @param {string} nodeId 
         * @param {string} tid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNodeNextFresh(nodeId: string, tid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNodeNextFresh(nodeId, tid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeApi.getNodeNextFresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing node
         * @summary battle vote a node
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNodeBattleVote(nodeData: NodeData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNodeBattleVote(nodeData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeApi.updateNodeBattleVote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing node
         * @summary fresh vote a node
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNodeFlag(nodeData: NodeData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNodeFlag(nodeData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeApi.updateNodeFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing node
         * @summary fresh vote a node
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNodeFreshVote(nodeData: NodeData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNodeFreshVote(nodeData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeApi.updateNodeFreshVote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing node
         * @summary Update a nodes title and description
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNodeTitle(nodeData: NodeData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNodeTitle(nodeData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeApi.updateNodeTitle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing node
         * @summary add or remove videos from a node
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNodeVideoEdit(nodeData: NodeData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNodeVideoEdit(nodeData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeApi.updateNodeVideoEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing node
         * @summary Update a nodes video votes
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNodeVideoVote(nodeData: NodeData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNodeVideoVote(nodeData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeApi.updateNodeVideoVote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NodeApi - factory interface
 * @export
 */
export const NodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NodeApiFp(configuration)
    return {
        /**
         * Add a new node
         * @summary Add a new node
         * @param {NodeData} nodeData Create a new node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNode(nodeData: NodeData, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePostNode> {
            return localVarFp.addNode(nodeData, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a specific node.
         * @summary Delete a node
         * @param {string} nodeId 
         * @param {string} tid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNode(nodeId: string, tid: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteNode(nodeId, tid, options).then((request) => request(axios, basePath));
        },
        /**
         * get wiki node
         * @summary get wiki node
         * @param {string} nodeId 
         * @param {string} tid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNode(nodeId: string, tid: string, options?: RawAxiosRequestConfig): AxiosPromise<NodeData> {
            return localVarFp.getNode(nodeId, tid, options).then((request) => request(axios, basePath));
        },
        /**
         * get next top battle tested ID
         * @summary get next top battle tested ID
         * @param {string} nodeId 
         * @param {string} tid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeNextBattleTested(nodeId: string, tid: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getNodeNextBattleTested(nodeId, tid, options).then((request) => request(axios, basePath));
        },
        /**
         * get next top fresh ID
         * @summary get next top fresh ID
         * @param {string} nodeId 
         * @param {string} tid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeNextFresh(nodeId: string, tid: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getNodeNextFresh(nodeId, tid, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing node
         * @summary battle vote a node
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeBattleVote(nodeData: NodeData, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.updateNodeBattleVote(nodeData, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing node
         * @summary fresh vote a node
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeFlag(nodeData: NodeData, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateNodeFlag(nodeData, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing node
         * @summary fresh vote a node
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeFreshVote(nodeData: NodeData, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.updateNodeFreshVote(nodeData, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing node
         * @summary Update a nodes title and description
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeTitle(nodeData: NodeData, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.updateNodeTitle(nodeData, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing node
         * @summary add or remove videos from a node
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeVideoEdit(nodeData: NodeData, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateNodeVideoEdit(nodeData, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing node
         * @summary Update a nodes video votes
         * @param {NodeData} nodeData Update an existent node
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNodeVideoVote(nodeData: NodeData, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.updateNodeVideoVote(nodeData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NodeApi - object-oriented interface
 * @export
 * @class NodeApi
 * @extends {BaseAPI}
 */
export class NodeApi extends BaseAPI {
    /**
     * Add a new node
     * @summary Add a new node
     * @param {NodeData} nodeData Create a new node
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeApi
     */
    public addNode(nodeData: NodeData, options?: RawAxiosRequestConfig) {
        return NodeApiFp(this.configuration).addNode(nodeData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a specific node.
     * @summary Delete a node
     * @param {string} nodeId 
     * @param {string} tid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeApi
     */
    public deleteNode(nodeId: string, tid: string, options?: RawAxiosRequestConfig) {
        return NodeApiFp(this.configuration).deleteNode(nodeId, tid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get wiki node
     * @summary get wiki node
     * @param {string} nodeId 
     * @param {string} tid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeApi
     */
    public getNode(nodeId: string, tid: string, options?: RawAxiosRequestConfig) {
        return NodeApiFp(this.configuration).getNode(nodeId, tid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get next top battle tested ID
     * @summary get next top battle tested ID
     * @param {string} nodeId 
     * @param {string} tid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeApi
     */
    public getNodeNextBattleTested(nodeId: string, tid: string, options?: RawAxiosRequestConfig) {
        return NodeApiFp(this.configuration).getNodeNextBattleTested(nodeId, tid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get next top fresh ID
     * @summary get next top fresh ID
     * @param {string} nodeId 
     * @param {string} tid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeApi
     */
    public getNodeNextFresh(nodeId: string, tid: string, options?: RawAxiosRequestConfig) {
        return NodeApiFp(this.configuration).getNodeNextFresh(nodeId, tid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing node
     * @summary battle vote a node
     * @param {NodeData} nodeData Update an existent node
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeApi
     */
    public updateNodeBattleVote(nodeData: NodeData, options?: RawAxiosRequestConfig) {
        return NodeApiFp(this.configuration).updateNodeBattleVote(nodeData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing node
     * @summary fresh vote a node
     * @param {NodeData} nodeData Update an existent node
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeApi
     */
    public updateNodeFlag(nodeData: NodeData, options?: RawAxiosRequestConfig) {
        return NodeApiFp(this.configuration).updateNodeFlag(nodeData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing node
     * @summary fresh vote a node
     * @param {NodeData} nodeData Update an existent node
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeApi
     */
    public updateNodeFreshVote(nodeData: NodeData, options?: RawAxiosRequestConfig) {
        return NodeApiFp(this.configuration).updateNodeFreshVote(nodeData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing node
     * @summary Update a nodes title and description
     * @param {NodeData} nodeData Update an existent node
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeApi
     */
    public updateNodeTitle(nodeData: NodeData, options?: RawAxiosRequestConfig) {
        return NodeApiFp(this.configuration).updateNodeTitle(nodeData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing node
     * @summary add or remove videos from a node
     * @param {NodeData} nodeData Update an existent node
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeApi
     */
    public updateNodeVideoEdit(nodeData: NodeData, options?: RawAxiosRequestConfig) {
        return NodeApiFp(this.configuration).updateNodeVideoEdit(nodeData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing node
     * @summary Update a nodes video votes
     * @param {NodeData} nodeData Update an existent node
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeApi
     */
    public updateNodeVideoVote(nodeData: NodeData, options?: RawAxiosRequestConfig) {
        return NodeApiFp(this.configuration).updateNodeVideoVote(nodeData, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TopicApi - axios parameter creator
 * @export
 */
export const TopicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new topic
         * @summary Add a new topic
         * @param {Topic} topic Create a new topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTopic: async (topic: Topic, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('addTopic', 'topic', topic)
            const localVarPath = `/topic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topic, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a specific node.
         * @summary Delete a node
         * @param {string} topicId ID of the node to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopic: async (topicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('deleteTopic', 'topicId', topicId)
            const localVarPath = `/topic/{topicId}`
                .replace(`{${"topicId"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get all topics
         * @summary get all topics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopics: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/topic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing topic by Id
         * @summary Update an existing topic
         * @param {Topic} topic Update an existent topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopic: async (topic: Topic, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'topic' is not null or undefined
            assertParamExists('updateTopic', 'topic', topic)
            const localVarPath = `/topic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topic, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TopicApi - functional programming interface
 * @export
 */
export const TopicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TopicApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new topic
         * @summary Add a new topic
         * @param {Topic} topic Create a new topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTopic(topic: Topic, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePostTopic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTopic(topic, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TopicApi.addTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a specific node.
         * @summary Delete a node
         * @param {string} topicId ID of the node to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTopic(topicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTopic(topicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TopicApi.deleteTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get all topics
         * @summary get all topics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopics(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Topic>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopics(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TopicApi.getTopics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing topic by Id
         * @summary Update an existing topic
         * @param {Topic} topic Update an existent topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTopic(topic: Topic, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTopic(topic, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TopicApi.updateTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TopicApi - factory interface
 * @export
 */
export const TopicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TopicApiFp(configuration)
    return {
        /**
         * Add a new topic
         * @summary Add a new topic
         * @param {Topic} topic Create a new topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTopic(topic: Topic, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePostTopic> {
            return localVarFp.addTopic(topic, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a specific node.
         * @summary Delete a node
         * @param {string} topicId ID of the node to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopic(topicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTopic(topicId, options).then((request) => request(axios, basePath));
        },
        /**
         * get all topics
         * @summary get all topics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopics(options?: RawAxiosRequestConfig): AxiosPromise<Array<Topic>> {
            return localVarFp.getTopics(options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing topic by Id
         * @summary Update an existing topic
         * @param {Topic} topic Update an existent topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopic(topic: Topic, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTopic(topic, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TopicApi - object-oriented interface
 * @export
 * @class TopicApi
 * @extends {BaseAPI}
 */
export class TopicApi extends BaseAPI {
    /**
     * Add a new topic
     * @summary Add a new topic
     * @param {Topic} topic Create a new topic
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    public addTopic(topic: Topic, options?: RawAxiosRequestConfig) {
        return TopicApiFp(this.configuration).addTopic(topic, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a specific node.
     * @summary Delete a node
     * @param {string} topicId ID of the node to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    public deleteTopic(topicId: string, options?: RawAxiosRequestConfig) {
        return TopicApiFp(this.configuration).deleteTopic(topicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get all topics
     * @summary get all topics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    public getTopics(options?: RawAxiosRequestConfig) {
        return TopicApiFp(this.configuration).getTopics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing topic by Id
     * @summary Update an existing topic
     * @param {Topic} topic Update an existent topic
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    public updateTopic(topic: Topic, options?: RawAxiosRequestConfig) {
        return TopicApiFp(this.configuration).updateTopic(topic, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * return user
         * @summary return authenticated user details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This can only be done by the logged in user or admin.
         * @summary Delete user
         * @param {string} userId The name that needs to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user by user name
         * @param {string} userId The name that needs to be fetched. Use user1 for testing. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByName: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserByName', 'userId', userId)
            const localVarPath = `/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This can only be done by the logged in user.
         * @summary Update user
         * @param {User} user Update an existent user in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (user: User, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'user' is not null or undefined
            assertParamExists('updateUser', 'user', user)
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * return user
         * @summary return authenticated user details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAuth2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.authUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This can only be done by the logged in user or admin.
         * @summary Delete user
         * @param {string} userId The name that needs to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user by user name
         * @param {string} userId The name that needs to be fetched. Use user1 for testing. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserByName(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserByName(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUserByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This can only be done by the logged in user.
         * @summary Update user
         * @param {User} user Update an existent user in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(user: User, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(user, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * return user
         * @summary return authenticated user details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUser(options?: RawAxiosRequestConfig): AxiosPromise<ResponseAuth2> {
            return localVarFp.authUser(options).then((request) => request(axios, basePath));
        },
        /**
         * This can only be done by the logged in user or admin.
         * @summary Delete user
         * @param {string} userId The name that needs to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user by user name
         * @param {string} userId The name that needs to be fetched. Use user1 for testing. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByName(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.getUserByName(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * This can only be done by the logged in user.
         * @summary Update user
         * @param {User} user Update an existent user in the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(user: User, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUser(user, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * return user
     * @summary return authenticated user details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public authUser(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).authUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This can only be done by the logged in user or admin.
     * @summary Delete user
     * @param {string} userId The name that needs to be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteUser(userId: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user by user name
     * @param {string} userId The name that needs to be fetched. Use user1 for testing. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserByName(userId: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserByName(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This can only be done by the logged in user.
     * @summary Update user
     * @param {User} user Update an existent user in the store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateUser(user: User, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).updateUser(user, options).then((request) => request(this.axios, this.basePath));
    }
}



